import { useTheme, lighten } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { UmbrellaIcon } from "../../../../assets/icons";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";
const MyClientTeamPresenceAndLeavesVacationTrackingLink = () => {
  const theme = useTheme();
  const tRP = "components.custom_widget_links.my_client_team_presence_and_leaves";
  const { t } = useTranslation();

  return (
    <IconAndTitleContainer
      title={`${t(`${tRP}.vacation_tracking`)}`}
      titleStyle={{ color: lighten(theme.palette.primary.main, 0.2) }}
      Icon={UmbrellaIcon}
      IconStyle={{ color: lighten(theme.palette.primary.main, 0.2), width: "50px" }}
    />
  );
};

export default MyClientTeamPresenceAndLeavesVacationTrackingLink;
